<template>
    <div class="page error">
        <div class="contents-wrapper">
            <p class="error-text">존재하지 않는 페이지입니다.<br/>
            메인으로 이동해 주세요.</p>
            <router-link class="button btnLink" to="/">메인으로 이동</router-link>
        </div>
    </div>
</template>
<script>
export default {
	name: 'errorPage'
}
</script>
<style lang="scss">
    .error {
        .contents-wrapper {
            padding-top: 240px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .error-text {
                font-size: 18px;
                font-weight: 500;
                text-align: center;
                & + .button {
                    margin-top: 16px;
                }
            }
        }
    }
</style>
